import { TextInput } from '@mantine/core';
import { IFormInputSpecValueMap } from 'pages/revisions-module/template-editor/editors/form/types';

interface ValueMapInputPreviewProps {
  spec: IFormInputSpecValueMap;
}

/**
 * Preview for the value map input type.
 */
export default function ValueMapInputPreview({ spec }: ValueMapInputPreviewProps) {
  return (
    <TextInput
      size="sm"
      readOnly
      placeholder="Hodnota podľa mapy"
      description={`Zdroj: ${spec.sourceInput || 'nevybrané'}`}
    />
  );
}
